import classNames from "classnames";
import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import { CaretDown } from "components/icons/CaretDown";
import { pluralize } from "utils/pluralize";
import {
  OtherDocument,
  useGetOtherDocumentsQuery,
} from "v2/store/entityDocumentsApi";
import { FileRow } from "./FileRow";

type UnmatchedDocumentsPanelProps = {
  entityId: string;
  count: number;
};

const EMPTY_DOCUMENTS: OtherDocument[] = [];

export const UnmatchedDocumentsPanel = ({
  entityId,
  count,
}: UnmatchedDocumentsPanelProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data } = useGetOtherDocumentsQuery(
    { entityId },
    { skip: !isOpen || !entityId }
  );

  const documents = data?.documents ?? EMPTY_DOCUMENTS;

  const verb = count === 1 ? "doesn't" : "don't";
  const message = `${pluralize(
    count,
    "file",
    "files"
  )} ${verb} match any existing category and have been placed in Others for review.`;

  const caretClassName = classNames(
    "t-flex t-transition t-duration-300 t-ease-in-out",
    isOpen ? "-t-rotate-180" : "t-rotate-0"
  );

  const handleToggle = (): void => setIsOpen((prev) => !prev);

  return (
    <div className="t-flex t-flex-col t-gap-3 t-rounded-lg t-border t-border-solid t-border-blue-20 t-bg-blue-0 t-p-3">
      <div className="t-flex t-items-center t-gap-2">
        <p className="t-m-0 t-flex-1 t-text-body-sm t-text-text-30">
          {message}
        </p>

        <Button
          type="button"
          customType="ghost"
          size="small"
          onClick={handleToggle}
          rightIcon={
            <span className={caretClassName}>
              <CaretDown width="12" height="12" />
            </span>
          }
        >
          View
        </Button>
      </div>

      {isOpen &&
        documents.map((document) => (
          <FileRow
            key={document.id}
            entityId={entityId}
            section={null}
            file={{ uuid: document.id, name: document.name, fileType: "" }}
          />
        ))}
    </div>
  );
};
